const removeNullThreshold = thresholds => (
  thresholds.filter(threshold => (
    threshold &&
    threshold.key &&
    threshold.key !== 'null'
  ))
)

export const parseCmAdaptativeThresholds = (rawConfig) => {
  if (!rawConfig) return []

  try {
    const parsed = typeof rawConfig === 'string' ? JSON.parse(rawConfig) : rawConfig
    return Array.isArray(parsed) ? removeNullThreshold(parsed) : []
  } catch (err) {
    return []
  }
}
